import HeroSection from './HeroSection';
import ServicesSection from './ServicesSection';
import ReferencesSection from './ReferencesSection';
import Footer from '../../components/footer/Footer';
import Translator from '../../translates/Translator';
import usePageMeta from '../../hooks/usePageMeta';

const HomePage = () => {
    const t = Translator();
    usePageMeta(`IKA DATA — ${t("ikadata-moto")}`, t("ikadata-description"));

    return (
        <div className='home-page'>
            <HeroSection />
            <ServicesSection />
            <ReferencesSection />
            <Footer />
        </div>
    );
};

export default HomePage;
